import * as React from 'react'
import {
  Bar,
  Brush,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import * as classNames from './dosage-chart.css'

export interface IProps {
  width: string | number
  height: string | number
  minWidth?: number
  minHeight?: number
  data: {
    date: string
    prescribed: number
    completed: number
  }[]
  title?: string
  /**
   * Base value which informs on how to scale the chart maximum.
   * Maximum set to 1.5 times the reference value.
   */
  referenceValue?: number
}

// margin necessary to prevent clipping the Date labels for the Brush component
const CHART_X_MARGIN_LEFT = 34
const CHART_X_MARGIN_RIGHT = 90

export class DosageChart extends React.Component<IProps, {}> {
  public render() {
    const { referenceValue } = this.props
    const domainMax = referenceValue ? referenceValue * 1.5 : 'auto'
    const chartData = this.props.data.map((datum) => ({
      'Completed Minutes': datum.completed,
      'Target Minutes': datum.prescribed,
      'date': datum.date,
    }))

    return (
      <div className={classNames.container}>
        <div className={classNames.headerContainer} style={{ width: this.props.width }}>
          <h2 className={classNames.header}>{this.props.title}</h2>

        </div>
        <ResponsiveContainer
          width={this.props.width}
          height={this.props.height}
          minWidth={this.props.minWidth}
          minHeight={this.props.minHeight}
        >
          <ComposedChart data={chartData} margin={{ left: CHART_X_MARGIN_LEFT, right: CHART_X_MARGIN_RIGHT }}>
            <XAxis dataKey='date' />
            <YAxis domain={[0, domainMax]} label={<h1>minutes</h1>} />
            <Tooltip />
            <Bar dataKey='Completed Minutes' fill='#00b5f0' />
            <Line dataKey='Target Minutes' type='step' dot={false} stroke='#cc3333' />
            <Brush dataKey='date' height={30} stroke='#183a50'/>
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/prescription/dosage-chart.tsx